import { ensureTrailingSlash } from '../utils/urlHelper';
import ApiServiceBase from './apiServiceBase';
import { ILibraryTagsRequest, ILibraryTagsResponse } from './models/tags';
import { AxiosRequestConfig, CancelToken, Method } from 'axios';

export default class LookupApiService extends ApiServiceBase {
	constructor(basePath: string) {
		super(basePath);
	}

	protected createBaseRequest(): AxiosRequestConfig {
		const baseConfig = super.createBaseRequest();
		return {
			...baseConfig,
			baseURL: ensureTrailingSlash(baseConfig.baseURL) + 'services/lookup/'
		};
	}

	public async fetchLibraryTagsAsync(
		data: ILibraryTagsRequest,
		cancelToken?: CancelToken
	): Promise<ILibraryTagsResponse> {
		const request = {
			url: 'fetchlibrarytags',
			method: 'post' as Method,
			data,
			cancelToken,
			...this.createBaseRequest()
		};

		const response = await super.sendAsync<ILibraryTagsResponse>(request);
		this.throwIfFailedResponse(response, localize('Error while fetching tags.'));

		return response.data ?? null;
	}
}
